import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Tooltip: Component = ({
  parentClassName, className,
  children,
  content,
  htmlContext: Wrapper = 'div', // Default to 'div' if not provided
}) => (
  <Wrapper className={cx(styles.containerRoot, parentClassName)}>
    {children}
    <div className={cx(styles.containerTooltip, className)}>
      {content}
    </div>
  </Wrapper>
);
